export default {
  attach_all_file: '所有文件',
  attach_root_folder: '根目录',
  attach_table_name: '名称',
  attach_table_size: '大小',
  attach_table_permissions_read: '读权限',
  attach_table_permissions_write: '写权限',
  attach_table_create_user: '创建人',
  attach_table_create_time: '创建时间',
  attach_table_dir_rename: '目录重命名',

  attach_confirm_delete_attach_title: '确定删除该附件?',
  attach_confirm_delete_attach_content: '附件名称: {name}',
  attach_confirm_delete_dir_title: '确定删除该目录?',
  attach_confirm_delete_dir_content: '目录名称: {name}',

  attach_menu: '附件',
  attach_menu_add: '附件添加',

  attach_form_name: '附件名称',
  attach_form_name_placeholder: '请输入附件名称',
  attach_form_status: '附件状态',
  attach_form_status_placeholder: '请选择状态',
  attach_form_description: '附件描述',
  attach_form_description_placeholder: '请输入附件描述',
  attach_form_icon: '附件图标',
  attach_form_bind_username: '绑定用户',
  attach_form_bind_username_placeholder: '请选择要绑定的用户',
  attach_form_app_id_placeholder: '请输入appId',
  attach_form_app_secret_placeholder: '请输入appSecret',
  attach_form_auto_generation_placeholder: '由系统自动生成',
  attach_form_folder_search_placeholder: '搜索文件夹',
  attach_form_file_search_placeholder: '搜索文件',

  // 右键菜单
  attach_menu_new_folder: '新建文件夹',
  attach_menu_upload: '上传附件',
  attach_menu_share: '分享',
  attach_menu_edit: '编辑',
  attach_menu_download: '下载附件',
  attach_menu_delete: '删除',
  attach_menu_rename: '重命名',

  // 表单标签
  attach_form_type: '附件类型',
  attach_form_type_placeholder: '请选择附件类型',
  attach_form_dir_type: '附件类型',
  attach_form_dir_type_placeholder: '请选择附件类型',
  attach_form_folder: '文件夹',
  attach_form_file_name: '文件名称',
  attach_form_file_name_placeholder: '请输入文件名称',
  attach_form_file_size: '文件大小',
  attach_form_folder_placeholder: '请选择文件夹',
  attach_form_new_folder: '新建文件夹',
  attach_form_edit_folder: '编辑文件夹',
  attach_form_folder_name: '文件夹名称',
  attach_form_read_permission: '文件读权限',
  attach_form_write_permission: '文件写权限',
  attach_form_download_permission: '下载权限',
  attach_form_file_desc: '文件描述',
  attach_form_file_desc_placeholder: '请输入文件描述',
  attach_form_folder_desc: '文件夹描述',
  attach_form_attach_upload: '附件上传',
  attach_form_attach_edit: '编辑附件',
  attach_form_path: '路径',
  attach_form_folder_read_permission: '文件夹读权限',
  attach_form_folder_write_permission: '文件夹写权限',

  // 表单占位符
  attach_form_upload_placeholder: '请上传文件',
  attach_form_folder_name_placeholder: '请输入文件夹名称',
  attach_form_upload_target_folder: '选择上传文件夹',
  attach_form_read_permission_placeholder: '选择读权限等级',
  attach_form_write_permission_placeholder: '选择写权限等级',
  attach_form_download_permission_placeholder: '选择下载权限等级',
  attach_form_folder_desc_placeholder: '请输入简单描述',
  attach_form_min_level_limit_tips: '不能低于文件夹权限等级{level}',

  // 其他可能需要的字段
  attach_title: '文档附件',
  attach_upload_success: '上传成功',
  attach_upload_failed: '上传失败',
  attach_delete_success: '删除成功',
  attach_rename_success: '重命名成功',
  attach_create_folder_success: '创建文件夹成功',
  attach_edit_folder_success: '编辑文件夹成功',

  // 确认提示
  attach_confirm_delete: '确定要删除该{type}吗？',
  attach_confirm_delete_folder: '删除文件夹将同时删除其下所有文件，是否继续？',

  // 权限等级
  attach_permission_public: '公开',
  attach_permission_private: '私有',
  attach_permission_custom: '自定义',

  attach_share_title: '附件分享',
  attach_share_file_count: '{count}个文件',
  attach_share_validity: '有效期',
  attach_share_validity_1_day: '1天',
  attach_share_validity_7_days: '7天',
  attach_share_validity_30_days: '30天',
  attach_share_validity_forever: '永久有效',
  attach_share_validity_days: '{days}天',
  attach_share_validity_date: '截止{date}前有效',
  attach_share_access_code: '提取码',
  attach_share_need_code: '需要',
  attach_share_no_code: '不需要',
  attach_share_access_code_input: '设置提取码',
  attach_share_access_code_placeholder: '请输入提取码',
  attach_share_continue: '继续分享',
  attach_share_success_title: '分享成功',
  attach_share_success_msg: '成功创建分享链接',
  attach_share_link_placeholder: '分享链接',
  attach_share_copy_link: '复制链接',
  attach_share_copy_success: '复制成功',
  attach_share_copy_failed: '复制失败',
  attach_share_validity_required: '请选择有效期',
  attach_share_access_code_rule: '请输入4位提取码',
  attach_share_link: '链接',
  attach_share_name: '名称',
  attach_share_size: '大小',
  attach_share_expired: '文件分享已过期',

  attach_download_confirm: '确定下载文件？',

  attach_form_attach_type: '附件类型',
  attach_form_attach_type_normal: '普通',
  attach_form_attach_type_firmware: '固件',
  attach_form_attach_type_log: '日志',
  attach_form_attach_type_issue: '问题',

  attach_share_destroy_confirm: '确定销毁该分享？',
  attach_share_destroy_success: '销毁成功',
};
